'use strict';

exports.__esModule = true;
exports.advancedSearchBar = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _advancedSearchBarActions = require('../actions/advanced-search-bar-actions');

var _constants = require('../utils/constants');

var _dropdowns = require('../transformers/dropdowns');

var _data = require('../data');

var defaultData = _interopRequireWildcard(_data);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_RESULT_ITEM = {
	name: 'no results found'
};

var WITHIN_SELECTED = defaultData.withins.findIndex(function (item) {
	return item.value === _constants.DEFAULT_WITHIN;
});

var INITIAL_STATE = {
	sortTypeItems: defaultData.sortTypes,
	withinItems: defaultData.withins,
	locationItems: defaultData.locations,
	selectedSortType: defaultData.sortTypes[0],
	selectedWithin: defaultData.withins[WITHIN_SELECTED],
	selectedLocation: defaultData.locations[0]
};

var advancedSearchBar = exports.advancedSearchBar = function advancedSearchBar(state, action) {
	switch (action.type) {
		case _advancedSearchBarActions.TOGGLE_CALENDAR:
			return (0, _assign2.default)({}, state, { isCalendarOpen: action.focused });
		case _advancedSearchBarActions.UPDATE_SELECTED_LOCATION:
			return (0, _assign2.default)({}, state, { selectedLocation: (0, _dropdowns.transformSeletedLocation)(action.location), searchOnLoad: true, selectedPage: 1 });
		case _advancedSearchBarActions.RESET_LOCATION:
			{
				var stateClone = (0, _assign2.default)({}, state, { selectedPage: 1 });
				delete stateClone.selectedLocation;
				delete stateClone.locationItems;
				return (0, _assign2.default)({}, stateClone);
			}
		case _advancedSearchBarActions.UPDATE_SELECTED_KEYWORD:
			return (0, _assign2.default)({}, state, {
				selectedKeyword: action.keyword,
				searchedNetwork: action.keyword && action.keyword.networks && action.keyword.networks[0] || undefined,
				text: null,
				selectedPage: 1
			});
		case _advancedSearchBarActions.UPDATE_SELECTED_INSURER:
			return (0, _assign2.default)({}, state, { selectedInsurer: action.insurer, selectedPage: 1 });
		case _advancedSearchBarActions.UPDATE_SELECTED_LANGUAGE:
			return (0, _assign2.default)({}, state, { selectedLanguage: action.language, selectedPage: 1 });
		case _advancedSearchBarActions.UPDATE_SELECTED_WITHIN:
			return (0, _assign2.default)({}, state, { selectedWithin: action.within, selectedPage: 1 });
		case _advancedSearchBarActions.UPDATE_SELECTED_SEARCH_TYPE:
			return (0, _assign2.default)({}, state, { selectedSortType: action.sortType, selectedPage: 1 });
		case _advancedSearchBarActions.UPDATE_LOCATIONS:
			return (0, _assign2.default)({}, state, { locationItems: (0, _dropdowns.transformDropdownLocation)(action.locations), selectedPage: 1 });
		case _advancedSearchBarActions.UPDATE_SELECTED_GENDER:
			return (0, _assign2.default)({}, state, {
				selectedGender: action.gender === state.selectedGender ? null : action.gender,
				selectedPage: 1
			});
		case _advancedSearchBarActions.UPDATE_SELECTED_VIDEO_CONSULTATION:
			return (0, _assign2.default)({}, state, {
				videoConsultation: action.videoConsultation,
				selectedPage: 1
			});
		case _advancedSearchBarActions.ON_QUERY_STRING_PARSED:
			return (0, _assign2.default)({}, state, action.query);
		case _advancedSearchBarActions.UPDATE_SELECTED_TIME_FRAME:
			return (0, _assign2.default)({}, state, {
				selectedTimeFrame: action.timeFrame,
				selectedDates: action.dates,
				isCalendarOpen: false,
				selectedPage: 1
			});
		case _advancedSearchBarActions.UPDATE_KEYWORDS_AUTOCOMPLETE + '_REQUESTED':
			return (0, _assign2.default)({}, state, { text: action.actionData.filter });
		case _advancedSearchBarActions.UPDATE_TEXT:
			return (0, _assign2.default)({}, state, { text: action.text });
		case _advancedSearchBarActions.UPDATE_KEYWORDS_AUTOCOMPLETE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				keywordItems: action.response.matching_items || [NO_RESULT_ITEM],
				isKeywordDropdownOpen: true,
				selectedKeyword: null
			});
		case _advancedSearchBarActions.SET_LOCATION_INPUT_FIELD:
			return (0, _extends3.default)({}, state, {
				locationInputField: action.payload.locationInputField
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/search-page/lib/reducers/advanced-search-bar-reducers.js